import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: true,
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Supprime tout caractère non numérique
    const cleaned = value.replace(/\D/g, '');

    // Formate par groupes de deux chiffres
    return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
  }
}
